import { render } from "./NotificationsTableRow.vue?vue&type=template&id=43a80523&scoped=true"
import script from "./NotificationsTableRow.vue?vue&type=script&lang=js"
export * from "./NotificationsTableRow.vue?vue&type=script&lang=js"

import "./NotificationsTableRow.vue?vue&type=style&index=0&id=43a80523&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a80523"]])

export default __exports__